<template>
	<div>
		<div @click="HideMobMenu(true)" class="collapsed-menu d-flex flex-column">
			<div class="menu-section">
				<div class="top">
					<i class="icon ico-iouu"></i><span></span>
					<button @click="HideMobMenu(true)" class="btn"></button>
				</div>
				<ul>
					<li v-for="(item, i) in items" :key="`item${i}`" class="menu-item">
						<div v-if="item.path != null">
							<router-link v-if="!item.modal" :to="item.path"  active-class="active" v-bind:title="item.title">
								<i class="menu-item-icon" :class="item.iconClass"></i> <span class="menu-item-title">{{item.title}}</span>
							</router-link>
							<a href="#" v-if="item.modal" active-class="active" data-toggle="modal" v-bind:title="item.title" data-target="#modalMotivo">
								<i class="menu-item-icon" :class="item.iconClass"></i> <span class="menu-item-title">{{item.title}}</span>
							</a>
						</div>
						<div v-if="item.url != null">
							<a :href="item.url" target="_black"  active-class="active" v-bind:title="item.title">
								<i class="menu-item-icon" :class="item.iconClass"></i> <span class="menu-item-title">{{item.title}}</span>
							</a>
						</div>
					</li>
				</ul>
			</div>
			<div class="menu-default align-items-end">
				<ul class="menu-item">
					<li>
						<a :href="'/#/emprestimos/meus-emprestimos'" title="Quero empréstimo"><i class="ico-din-3"></i> <span>Quero empréstimo</span></a>
					</li>
					<li>
						<a :href="'/#/'+tipo+'/perfil/dados-pessoais'" title="Meu Perfil"><i class="ico-user"></i> <span>Meu Perfil</span></a>
					</li>
					<!-- <li>
						<a target="_blank" href="https://go.crisp.chat/chat/embed/?website_id=f03f9794-5017-436c-8fb2-570d8dc56607" title="Atendimento online"><i class="ico-ch-2"></i> <span>Atendimento online</span></a>
					</li> -->
					<li>
						<a target="_blank" href="http://ajuda.iouu.com.br" title="Central de Ajuda"><i class="ico-ch"></i> <span>Central de Ajuda</span></a>
					</li>
					<li>
						<a href="#" title="Sair" @click="logout"><i class="ico-exit"></i> <span>Sair</span></a>
					</li>
				</ul>      
			</div>
		</div>

	</div>
</template>

<script>
export default {
	props: {
	items: {required: true, type: Array},
	tipo: {required: true, type: String}
	},
	methods: {
	logout() {
		this.$store.dispatch('logout')
		this.$router.push('/login')
	},
	HideMobMenu(status) {
	var menu = document.getElementsByClassName('collapsed-menu');

	if(status == true && menu.length >= 1) {
		menu[0].classList.remove("show");
	}
	},
	}
}
</script>

<style lang="scss" scoped>

@import "../assets/styles/iouu/variables";
@import "../assets/styles/iouu/mixins";


.collapsed-menu,
.collapsed-menu .menu-item > .menu-item-title,
.collapsed-menu:hover,
.collapsed-menu:hover .menu-item > .menu-item-title {
	transition-duration: 0.3s;
	transition-delay: 0.1s;
}

.collapsed-menu {
	@include gradient-linear($c5,#222239);
	height: 100vh;
	width: 80px;
	overflow: hidden;
	z-index: 9!important;
	position: fixed;

	.menu-item > .menu-item-title {
		display: none;
	}

	&:hover {
		width: 300px;
		.menu-item > .menu-item-title {
			display: inline-block;
		}
	}
}

.menu-section {
	height: 100%;
}

.menu-default {
	ul {
		li {
			border-top: 1px solid $c6;

			&:last-child {
			padding: 8px 0;
			}
		}
	}

	@include xs {
		ul {
			// margin-bottom: 55px!important;
		}
	}
}

.collapsed-menu {

	.menu-section {
		position: relative;

		.top {
			i {
				position: absolute;
				color: #fff;
				@include font-size(65px);
				line-height: 80px;
				left: 20px;
				opacity: 0;
				transition: .5s;
			}

			span {
				background: url(../assets/images/ico-bv.png) no-repeat;
				background-size: 35px 35px;
				height: 35px;
				width: 35px;
				display: block;
				position: absolute;
				top: 22px;
				right: 25px;
				-webkit-transition-delay: 0.5s;
				transition-delay: 0.5s;
				-webkit-transition: .5s;
				transition: .5s;
				}

			button {
				&.btn {
					background: url(../assets/images/ico-bv.png) no-repeat;
					background-size: 35px 35px;
					height: 35px;
					width: 35px;
					display: none;
					position: absolute;
					top: 22px;
					right: 25px;
					-webkit-transition-delay: 0.5s;
					transition-delay: 0.5s;
					-webkit-transition: .5s;
					transition: .5s;
					outline: none;
					border: none;
					transform: rotate(180deg);
				}
			}
		}

		ul {
			margin-top: 80px;
			
			li {
				&:first-child {
					margin-bottom: 64px;
					padding: 10px 0;
				}
			}
		}
	}

	ul {
		margin:0px;
		padding:0px;
		list-style: none;

		li {
			display: flex;
			width: 300px;

			a {
				color: #fff;
				display: block;
				line-height: 45px;
				width: 100%;
				position: relative;
				border-left: 5px solid transparent;
				@include transition(all 600ms);

				&.active {
					border-left: 5px solid $c3!important;
				}

				&:hover {
					i {
						@include transition(all 600ms);
						color: $c3;
					}
				}
			}

			i {
				font-size: 25px;
				display: inline-block;
				float:left;
				line-height: 45px;
				padding: 0  0 0 20px;
				margin-right: 15px;
			}

			span {
				font-weight: 500;
				opacity: 0;
				-webkit-transition-delay: 0.5s;
				transition-delay: 0.5s;
				-webkit-transition: .5s;
				transition: .5s;
			}
		}
	}

	&:hover {

		.top {
			i {
				opacity: 1;
				transition-delay: 1s;
				transition: .5s;
			}

			span {
				transform: rotate(180deg);
				-webkit-transition: .5s;
				transition: .5s;
			}
		}

		ul {
			li {
				display: block;
				width: 300px;
				span {
				position:relative;
				display: inline-block;
				font-weight: 500;
				@include font-size(16px);
				opacity: 1;
				transition-delay: 0.5s;
				transition: .5s;
				-webkit-transition-delay: 0.5s;
				transition-delay: 0.5s;
				-webkit-transition: .5s;
				transition: .5s;      
				}
			}
		}
	}
}
	
	// ESTILO MENU 1024 <= 1440;
	@include ds  {
		.collapsed-menu {
			width: 60px;

			&:hover {
				width: 200px;
			}

			.menu-section {

				.top {

					i {
						@include font-size(55px);
						line-height: 65px;
						left: 15px;
					}

					span {
						background-size: 25px 25px;
						height:25px;
						width: 25px;
						top: 22px;
						right: 18px;				
					}
				}


				ul {
					margin-top: 65px;

					li {
						&:first-child {
							margin-bottom:10px;
							padding: 5px 0;
						}
					}
				}
			}
		}
		ul {
			li {
				width: 200px;

				a {
					line-height: 32px!important;
					border-left: 3px solid transparent!important;

					&.active {
						border-left: 3px solid $c3!important;
					}
				}

				i {
					font-size: 18px!important;
					line-height: 32px!important;
					padding: 0  0 0 15px!important;
					margin-right: 15px!important;
				}

				span {
					font-size: 10px!important;
					line-height: 10px;
				}
			}

		}
}
</style>


// WEBPACK FOOTER //
// src/components/SideMenu.vue